import React, { useState } from 'react';
import { OCCASIONS } from '../data/mock';
import SectionHeading from './SectionHeading';
import { ChevronDown } from 'lucide-react';

const Occasions = () => {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? OCCASIONS : OCCASIONS.slice(0, 18);

  return (
    <section className="section-pad bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHeading
          eyebrow="Every Celebration"
          title="Coconut Ideas for"
          accent="Every"
          tail="Occasion"
          subtitle="From weddings to workshops — 40+ occasions where personalized coconuts steal the show."
        />

        <div className="mt-12 flex flex-wrap gap-2.5 justify-center">
          {visible.map((o) => (
            <span
              key={o}
              className="inline-flex items-center bg-blush hover:bg-pink-brand hover:text-white text-stone-700 rounded-full px-4 py-2 text-sm font-medium transition-colors cursor-default"
              data-testid={`occasion-chip-${o.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            >
              {o}
            </span>
          ))}
        </div>

        {OCCASIONS.length > 18 && (
          <div className="mt-8 text-center">
            <button
              type="button"
              onClick={() => setExpanded(!expanded)}
              className="inline-flex items-center gap-1.5 text-pink-brand font-semibold text-sm hover:gap-2 transition-all"
              data-testid="occasions-toggle-button"
            >
              {expanded ? 'Show fewer' : `View all ${OCCASIONS.length}+ occasions`}
              <ChevronDown className={`w-4 h-4 transition-transform ${expanded ? 'rotate-180' : ''}`} />
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Occasions;
